import React, { useEffect, useState } from 'react';
import styles from 'styles/modules/Expertise.module.scss';
import AddContent from './AddContent';
import ExpertiseDropdown from 'components/ExpertiseDropdown';
import Tags from 'components/Tags';
import { useDispatch, useSelector } from 'react-redux';
import { expertiseSelector, fetchExpertise } from 'store/expertise';
import { profile } from 'lang/en.json';
import { authSelector } from 'store/auth';
import Typo from 'components/Typo';

const Expertise = ({ update, data }) => {
    const { isAuthorized } = useSelector(authSelector);
    const dispatch = useDispatch();
    const globalExpertise = useSelector(expertiseSelector);

    const [limit, setLimit] = useState(7);
    const [activeAdder, setActiveAdder] = useState(false);
    // TODO: split this file into smaller parts

    const [activeTags, setActivetags] = useState(data);

    useEffect(() => {
        if (!globalExpertise.data) {
            dispatch(fetchExpertise());
        }
    }, []);

    useEffect(() => {
        setActivetags(data);
    }, [data]);

    const addTag = (item) => {
        if (!activeTags.includes(item)) {
            setActivetags([...activeTags, item]);
            setLimit(limit + 1);
            update([...activeTags, item]);
        }
    };

    const removeTag = (item) => {
        if (activeTags.includes(item)) {
            let active = activeTags.filter((tag) => tag !== item);
            setActivetags(active);
            setLimit(limit - 1);
            update(active);
        }
    };

    const expertiseList = (
        <Tags
            disabled
            data={{
                allTags: globalExpertise.data ? globalExpertise.data : [],
                activeTags: activeTags,
                onClick: (tag) => {
                    removeTag(tag);
                },
                limit,
            }}
        />
    );

    let adderRef = React.createRef();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                activeAdder &&
                adderRef &&
                !adderRef.current.contains(e.target)
            ) {
                setActiveAdder(false);
            }
        };
        document.addEventListener('mouseup', handleClickOutside);
        return function cleanup() {
            document.removeEventListener('mouseup', handleClickOutside);
        };
    }, []);

    let dropdownData = {
        name: 'expertise',
        inline: false,
        items: globalExpertise.data ? globalExpertise.data : [],
        exclude: activeTags,
        callback: (item) => {
            addTag(item);
        },
    };

    if (!activeAdder) {
        dropdownData = {
            ...dropdownData,
            query: '',
            showList: false,
        };
    }

    return (
        <section>
            <div className={'mb-xxs'}>
                <Typo variant={'body'} Tag={'label'} htmlFor="">
                    {isAuthorized
                        ? profile.header.experts.sidebar.expertise
                        : profile.header.expertise.title}
                    :
                </Typo>
            </div>

            <div className={styles.expertise}>
                <aside className={styles.list} ref={adderRef}>
                    {expertiseList}
                    {isAuthorized && (
                        <div
                            className={[
                                styles.addTag,
                                activeAdder ? styles.addTagActive : null,
                            ].join(' ')}
                        >
                            <div className={styles.dropdown}>
                                <ExpertiseDropdown data={dropdownData} />
                            </div>
                            <div className={styles.add}>
                                <AddContent
                                    data={{
                                        direction: 'row',
                                        label:
                                            !activeAdder &&
                                            activeTags.length < 1
                                                ? 'Add Expertise'
                                                : null,
                                        active: activeAdder,
                                        onClick: () => {
                                            setActiveAdder(!activeAdder);
                                        },
                                    }}
                                />
                            </div>
                            {limit < data?.length && (
                                <button
                                    onClick={() => setLimit(activeTags?.length)}
                                    className={[styles.loadMore]}
                                >
                                    {`+${data?.length - limit} more`}
                                </button>
                            )}
                        </div>
                    )}
                </aside>
            </div>
        </section>
    );
};

export default Expertise;
